import type {CopilotSpaceResource} from '../types'

export function resourceMetadataToRailsPayload(resource: CopilotSpaceResource) {
  switch (resource.type) {
    case 'repository':
      return {
        repository_id: resource.repositoryId,
      }
    case 'github_file':
      return {
        repository_id: resource.repositoryId,
        file_path: resource.filePath,
        sha: resource.sha,
      }
    case 'free_text':
      return {
        text: resource.text,
        name: resource.name,
      }
    case 'github_issue':
    case 'github_pull_request':
      return {
        repository_id: resource.repositoryId,
        number: resource.number,
      }
    case 'uploaded_text_file':
      return {name: resource.name}
    case 'media_content':
      return {
        media_type: resource.mediaType,
        name: resource.name,
        url: resource.url,
        height: resource.height,
        width: resource.width,
      }
    default:
      throw new Error(`Unsupported resource`)
  }
}
